import React, { useState, useEffect } from 'react';
import { LoanApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { formatCurrency } from '../../../common/SharedFunctions';
import { RefreshEvents } from '../../../common/SharedEvents';
import { LoanPageType, LoanStatusType } from '../LoanConstants';
import { getLoanTypeForPageType } from '../LoanFunctions';

export const SummaryTotals = ({ pageType }) => {
    const loanApi = new LoanApi.LoanApi(applicationInsights);

    const [totals, set_totals] = useState(null);

    const styles = {
        summary: {
            padding: '10px 20px',
            fontSize: '17px',
            fontWeight: 'bold',
        },
    };

    //Reloaded on mount and whenever a loan is saved elsewhere in the app (see RefreshEvents below).
    const loadTotals = async (isActive = () => true) => {
        if (!pageType) {
            return;
        }

        if (pageType === LoanPageType.LOC) {
            const summaryTotalsResponse = await loanApi.getGrid_LOCLoans_Summary(LoanStatusType.Outstanding);
            if (summaryTotalsResponse.statusCode !== 200 || !isActive()) {
                return;
            }
            set_totals(summaryTotalsResponse.result);
        } else {
            const loanTypeId = getLoanTypeForPageType(pageType);
            const summaryTotalsResponse = await loanApi.getGrid_StandardLoans_Summary(loanTypeId, LoanStatusType.Outstanding);
            if (summaryTotalsResponse.statusCode !== 200 || !isActive()) {
                return;
            }
            set_totals(summaryTotalsResponse.result);
        }
    };

    useEffect(() => {
        let active = true;
        const isActive = () => active;
        //Named wrapper so the same reference is used to add and remove the listener.
        const onRefresh = () => loadTotals(isActive);

        const refreshEvents = new RefreshEvents();
        refreshEvents.addRefreshListener(onRefresh);

        loadTotals(isActive);

        return () => {
            active = false;
            refreshEvents.removeRefreshListener(onRefresh);
        };
    }, [pageType]);

    if (!pageType || !totals) {
        return null;
    }

    return (
        <div style={styles.summary}>
            {pageType === LoanPageType.LOC && (
                <>
                    {totals.masterNotes && (
                        <span>
                            <span style={{ textDecoration: 'underline' }}>Master Notes:</span>
                            &nbsp;{totals.masterNotes.count} {totals.masterNotes.count > 1 ? 'Lines' : 'Line'}
                            ,&nbsp;
                            {formatCurrency(totals.masterNotes.prommissoryNote, 0)}{' '}
                            Committed&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                    )}
                    {totals.subNotes && (
                        <span>
                            <span style={{ textDecoration: 'underline' }}>Sub Notes:</span>
                            &nbsp;{totals.subNotes.count} {totals.subNotes.count > 1 ? 'Sub-Notes' : 'Sub-Note'}
                            ,&nbsp;
                            {formatCurrency(totals.subNotes.prommissoryNote, 0)} Committed,{' '}
                            {formatCurrency(totals.subNotes.funded, 0)} Funded ({totals.subNotes?.fundingPercent}%)
                        </span>
                    )}
                </>
            )}
            {pageType !== LoanPageType.LOC && (
                <span>
                    {totals.count} {totals.count > 1 ? 'Loans' : 'Loan'},&nbsp;
                    {formatCurrency(totals.prommissoryNote, 0)} Committed,&nbsp;
                    {formatCurrency(totals.funded, 0)} Funded&nbsp; ({totals?.fundingPercent}%)
                </span>
            )}
        </div>
    );
};
